var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.864,
    height: 154.898,
    viewBox: "0 0 158.864 154.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(7.014 7.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M137.707,64.189v6.2A67.353,67.353,0,1,1,97.766,8.825",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#5046e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M101.059,6,33.706,73.421,13.5,53.215",
    transform: "translate(36.648 10.503)",
    fill: "none",
    stroke: "#5046e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.b66fd96544cb9477381b227089aefc6c.svg";
export { ForwardRef as ReactComponent };